export enum HttpHeader {
  WWW_AUTHENTICATE = 'WWW-Authenticate',
  AUTHORIZATION = 'Authorization',
  PROXY_AUTHENTICATE = 'Proxy-Authenticate',
  PROXY_AUTHORIZATION = 'Proxy-Authorization',
  AGE = 'AGE',
  CACHE_CONTROL = 'Cache-Control',
  CLEAR_SITE_DATA = 'Clear-Site-Data',
  EXPIRES = 'Expires',
  PRAGMA = 'Pragma',
  WARNING = 'Warning',
  LAST_MODIFIED = 'Last-Modified',
  ETAG = 'ETag',
  IF_MATCH = 'If-Match',
  IF_NONE_MATCH = 'If-None-Match',
  IF_MODIFIED_SINCE = 'If-Modified-Since',
  IF_UNMODIFIED_SINCE = 'If-Unmodified-Since',
  VARY = 'Vary',
  CONNECTION = 'Connection',
  KEEP_ALIVE = 'Keep-Alive',
  ACCEPT = 'Accept',
  ACCEPT_CHARSET = 'Accept-Charset',
  ACCEPT_ENCODING = 'Accept-Encoding',
  ACCEPT_LANGUAGE = 'Accept-Language',
  EXPECT = 'Expect',
  MAX_FORWARDS = 'Max-Forwards',
  COOKIE = 'Cookie',
  SET_COOKIE = 'Set-Cookie',
  ACCESS_CONTROL_ALLOW_ORIGIN = 'Access-Control-Allow-Origin',
  ACCESS_CONTROL_ALLOW_CREDENTIALS = 'Access-Control-Allow-Credentials',
  ACCESS_CONTROL_ALLOW_HEADERS = 'Access-Control-Allow-Headers',
  ACCESS_CONTROL_ALLOW_METHODS = 'Access-Control-Allow-Methods',
  ACCESS_CONTROL_EXPOSE_HEADERS = 'Access-Control-Expose-Headers',
  ACCESS_CONTROL_MAX_AGE = 'Access-Control-Max-Age',
  ACCESS_CONTROL_REQUEST_HEADERS = 'Access-Control-Request-Headers',
  ACCESS_CONTROL_REQUEST_METHOD = 'Access-Control-Request-Method',
  ORIGIN = 'Origin',
  TIMING_ALLOW_ORIGIN = 'Timing-Allow-Origin',
  DNT = 'DNT',
  TK = 'TK',
  CONTENT_DISPOSITION = 'Content-Disposition',
  CONTENT_LENGTH = 'Content-Length',
  CONTENT_TYPE = 'Content-Type',
  CONTENT_ENCODING = 'Content-Encoding',
  CONTENT_LANGUAGE = 'Content-Language',
  CONTENT_LOCATION = 'Content-Location',
  FORWARDED = 'Forwarded',
  X_FORWARDED_FOR = 'X-Forwarded-For',
  X_FORWARDED_HOST = 'X-Forwarded-Host',
  X_FORWARDED_PROTO = 'X-Forwarded-Proto',
  VIA = 'Via',
  LOCATION = 'Location',
  FROM = 'From',
  HOST = 'Host',
  REFERER = 'Referer',
  REFERRER_POLICY = 'Referrer-Policy',
  USER_AGENT = 'User-Agent',
  ALLOW = 'Allow',
  SERVER = 'Server',
}